module.exports = __webpack_public_path__ + "45abd64e5ba11eff16012f3bcbcce968.png";